import React, { useEffect, useRef } from 'react';
import { Container, Modal, Row, Col, Form, InputGroup } from 'react-bootstrap';
import { BsSearch } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import './styles.css'

const OnlinePaymentModal = ({ show, handleClose }) => {
    const citizenBodyRef = useRef(null);
    const citizenModalInfoRef = useRef(null);

    const navigate = useNavigate();


    // COMMON BUTTON STYLE (LOOKS LIKE TEXT)
    const textButtonStyle = {
        background: "none",
        border: "none",
        padding: 0,
        margin: 0,
        color: "inherit",
        cursor: "pointer",
        textAlign: "left",
        fontSize: "16px",
    };

    return (
        <Modal show={show} onHide={handleClose} className='citizen-modal'>
            <div className='citizenmodal-info' ref={citizenModalInfoRef}>
                <div className='citizen-body' ref={citizenBodyRef}>
                    <Modal.Header closeButton className='mx-5 px-0'>
                        <Modal.Title>
                            <a className="navbar-brand d-flex align-items-center" href="#">
                                <img src="images/logo.svg" alt="Logo" className='logo' />
                                <div className="brand-text ms-2">
                                    <img src="images/logo-text.svg" alt="Logo Text" className='logo-text' />
                                </div>
                            </a>
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div className='modalbody-head d-sm-block d-md-flex justify-content-between align-items-center mx-md-5 mx-sm-0'>
                            <div className='stat-head ms-5 d-flex'>
                                <h4>Online<br /><span>Payments</span></h4>
                            </div>

                            {/* SEARCH BAR */}
                            <InputGroup className="input-search mb-3" style={{ maxWidth: '400px', height: '50px', borderRadius: '30px', backgroundColor: 'white' }}>
                                <Form.Control
                                    placeholder="Search Service"
                                    aria-label="Search Service"
                                    style={{ borderRadius: '50px', border: '0px', padding: '10px 20px', background: 'transparent' }}
                                />
                                <InputGroup.Text style={{ background: 'transparent', border: 'none' }}>
                                    <BsSearch color="#b3b3b3" className='search' />
                                </InputGroup.Text>
                            </InputGroup>
                        </div>

                        <Container>
                            <Row className="mt-4">

                                {/* LEFT COLUMN */}
                                <Col xxl={6} xl={6} lg={6} md={12}>
                                    <div className="service-block mb-4">
                                        <span className='tax-head4'>Property Tax</span>
                                        <ul className='payment-list tax-ul'>
                                            <li>
                                                <button
                                                    style={textButtonStyle}
                                                    onClick={() => navigate("/LoginHouseTaxPayment")}
                                                >
                                                    Click Here to Pay Your House Tax
                                                </button>
                                            </li>
                                        </ul>
                                    </div>


                                      <div className="service-block mb-4">
                                        <span className='tax-head4'>Mutation Fee</span>
                                        <ul className='payment-list tax-ul'>
                                            <li>
                                                <button
                                                    style={textButtonStyle}
                                                    onClick={() => navigate("/MutationFeePayment")}
                                                >
                                                    Click Here to Pay Your Mutation Fee
                                                </button>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="service-block mb-4">
                                        <span className='tax-head3'>Tap Fee</span>
                                        <ul className='payment-list tax-ul'>
                                            <li>
                                                <button
                                                    style={textButtonStyle}
                                                    onClick={() => navigate("/OutsideTapFeePayment")}
                                                >
                                                    Click Here to Pay Your Water Tap Fee
                                                </button>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="service-block mb-4">
                                        <span className='tax-head4'>Trade License</span>
                                        <ul className='payment-list tax-ul'>
                                            <li>
                                                <button
                                                    style={textButtonStyle}
                                                    onClick={() => navigate("/OutSideTradeLicensePayment")}
                                                >
                                                    Click Here to Pay Your Trade License Fee
                                                </button>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="service-block mb-4">
                                        <span className='tax-head3'>Auctions</span>
                                        <ul className='payment-list tax-ul'>
                                            <li>
                                                <button
                                                    style={textButtonStyle}
                                                    onClick={() => navigate("/OutSideAuctionFeePayment")}
                                                >
                                                    Click Here to Pay Your Auction Fee
                                                </button>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="service-block mb-4">
                                        <span className='tax-head3'>Certificates</span>
                                        <ul className='payment-list tax-ul'>
                                            <li>
                                                <button
                                                    style={textButtonStyle}
                                                    onClick={() => navigate("/PropertyValuationFeePayment")}
                                                >
                                                    Click Here to Pay Your Property Valuation Certificate Fee
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </Col>

                                {/* RIGHT COLUMN */}
                                <Col xxl={6} xl={6} lg={6} md={12}>
                                    <div className="service-block mb-4">
                                        <span className='tax-head4'>Miscellaneous</span>
                                        <ul className='payment-list  tax-ul8'>

                                            <li>
                                                <button style={textButtonStyle} onClick={() => navigate("/donations")}>
                                                   Click Here to Pay Your Donation To Gram Panchayat
                                                </button>
                                            </li>

                                            <li>
                                                <button style={textButtonStyle} onClick={() => {navigate("/MiscellaneousFeeDeposit");handleClose()}}>
                                                    Click Here to Pay Your Deposit Fee
                                                </button>
                                            </li>

                                            <li>
                                                <button style={textButtonStyle} onClick={() => {navigate("/MiscellaneousFeeSalesGp");handleClose()}}>
                                                    Click Here to Pay Your Sale Of GP Produces
                                                </button>
                                            </li>

                                            <li>
                                                <button style={textButtonStyle} onClick={() => {navigate("/MiscellaneousFeeCertificate");handleClose()}}>
                                                    Click Here to Pay Your Miscellaneous Fee Certificate
                                                </button>
                                            </li>

                                            <li>
                                                <button style={textButtonStyle} onClick={() => {navigate("/MiscellaneousFeeNOCCertificate");handleClose()}}>
                                                    Click Here to Pay Your No Objection Certificate (NOC) Fee for industries
                                                </button>
                                            </li>

                                            <li>
                                                <button style={textButtonStyle} onClick={() => {navigate("/MiscellaneousFeeRTIDocument");handleClose()}}>
                                                    Click Here to Pay Your RTI Document Fee / Pay Your Garbage Fee / Pay Your Fines or Penalties
                                                </button>
                                            </li>

                                            {/* <li>
                                                <button style={textButtonStyle} onClick={() => {navigate("/MiscellaneousFeeGarbage");handleClose()}}>
                                                    Pay Your Garbage Fee
                                                </button>
                                            </li>

                                            <li>
                                                <button style={textButtonStyle} onClick={() => {navigate("/MiscellaneousFeePenalties");handleClose()}}>
                                                    Pay Your Fines / Penalties
                                                </button>
                                            </li> */}

                                        </ul>
                                    </div>
                                </Col>

                            </Row>
                        </Container>

                    </Modal.Body>
                </div>
            </div>
        </Modal>
    );
};

export default OnlinePaymentModal;
